import { FC, PropsWithChildren } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';
import { CircularProgress } from '@mui/material';

type LoaderProps = {
  isLoading: boolean;
};

const LoaderWrapper: FC<PropsWithClassName<PropsWithChildren<LoaderProps>>> = ({
  className,
  isLoading = false,
  children,
}) => {
  return isLoading ? (
    <div className={cn('relative min-h-32 bg-primary-400 bg-opacity-5', className)}>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <CircularProgress />
      </div>
    </div>
  ) : (
    children
  );
};

export default LoaderWrapper;
